var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70866 0.5C3.72742 0.5 0.5 3.65614 0.5 7.54945C0.5 11.4427 3.72742 14.5989 7.70866 14.5989C9.41141 14.5989 10.9763 14.0216 12.2097 13.0561L14.5528 15.3415L14.6151 15.394C14.8327 15.5514 15.1411 15.5335 15.3379 15.3405C15.5544 15.1282 15.554 14.7844 15.3369 14.5727L13.0214 12.3142C14.1987 11.0595 14.9173 9.38655 14.9173 7.54945C14.9173 3.65614 11.6899 0.5 7.70866 0.5ZM7.70866 1.5858C11.0767 1.5858 13.807 4.25582 13.807 7.54945C13.807 10.8431 11.0767 13.5131 7.70866 13.5131C4.34064 13.5131 1.61033 10.8431 1.61033 7.54945C1.61033 4.25582 4.34064 1.5858 7.70866 1.5858Z",
    fill: "#979592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e76a1f3401cb4e61f30b4594cae24508.svg";
export { ForwardRef as ReactComponent };